import type { FormKitOptionsList } from '@formkit/inputs'

export const COLORS = {
  black: 'bg-black text-white hover:bg-gray-700 focus:bg-gray-500',
  blue: 'bg-bunce-primary text-white hover:bg-blue-600 focus:bg-blue-700',
  'blue:outline':
    'bg-white border border-blue-500 text-blue-500 hover:bg-blue-50 focus:bg-blue-100',
  gray: 'bg-gray-500 text-white hover:bg-gray-400 focus:bg-gray-600',
  red: 'bg-red-500 text-white hover:bg-red-400 focus:bg-red-600',
  white:
    'bg-white border border-gray-300 text-black hover:bg-gray-100 focus:bg-gray-200',
} as const

export const SIZES = {
  sm: 'font-medium gap-2 px-5 py-[0.5rem] rounded-[4px] text-[12px]',
  lg: 'font-medium gap-3 px-10 py-[1.25rem] rounded-[4px] text-[16px]',
  md: 'font-medium gap-3 max-w-full px-[24px] py-[1rem] rounded-[4px] text-[14px]',
} as const

export const FontFamilyOptions: FormKitOptionsList = [
  { label: 'Andalé Mono', value: 'anadale mono, monospace' },
  { label: 'Arial', value: 'arial, sans-serif' },
  { label: 'Arial Black', value: 'arial black, sans-serif' },
  { label: 'Baskerville', value: 'baskerville, serif' },
  { label: 'Bradley Hand', value: 'bradley hand, cursive' },
  { label: 'Comic Sans MS', value: 'comic sans ms, cursive' },
  { label: 'Courier', value: 'courier, monospace' },
  { label: 'Georgia', value: 'georgia' },
  { label: 'Gill Sans', value: 'gill sans' },
  { label: 'Helvetica', value: 'helvetica, sans-serif' },
  { label: 'Impact', value: 'impact, sans-serif' },
  { label: 'Luminari', value: 'luminari, fantasy' },
  { label: 'Lucida', value: "'Lucida Grande', monospace" },
  { label: 'Monaco', value: 'monaco, monospace' },
  { label: 'Palatino', value: 'palatino' },
  { label: 'Tahoma', value: 'Tahoma, sans-serif' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Trebuchet MS', value: 'trebuchet ms, sans-serif' },
  { label: 'Verdana', value: 'verdana, sans-serif' },
]

FontFamilyOptions.map(({ label }) => label)
